import { Award, ArrowRight, Users, TrendingUp, Zap } from "lucide-react";
import { stats, whatsappUrl, heroImage } from "../mock";

const iconMap = { Award, Users, TrendingUp, Zap };

export default function Hero() {
  return (
    <section id="top" className="relative pt-24 pb-20 md:pt-32 md:pb-24 hero-gradient overflow-hidden">
      {/* subtle backdrop image */}
      <div
        className="absolute inset-0 opacity-25 mix-blend-luminosity"
        style={{
          backgroundImage: `url(${heroImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0a2e18]/70 via-[#0a2e18]/60 to-[#0a2e18]" />

      <div className="relative max-w-6xl mx-auto px-4 md:px-8 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-amber-400/40 bg-amber-400/10 text-amber-300 text-xs font-semibold mb-6">
          <Award className="w-3.5 h-3.5" /> Empresa certificada GPTW 2025-2026
        </div>

        <h1 className="text-white text-4xl md:text-6xl lg:text-7xl font-extrabold leading-[1.05] tracking-tight">
          Transforme Conexões em <br />
          <span className="gold-gradient-text">Renda Recorrente</span>
        </h1>
        <p className="mt-6 text-white/95 text-xl md:text-3xl font-semibold max-w-4xl mx-auto">
          Seu Aplicativo, Multiplicando Seus Ganhos e Ajudando Mais Pessoas.
        </p>
        <p className="mt-6 max-w-2xl mx-auto text-slate-300 text-base md:text-lg leading-relaxed">
          Torne-se um Licenciado iGreen Energy e ajude milhares de pessoas a economizar na conta de luz enquanto você constrói uma carreira de sucesso com <span className="text-white font-semibold">ganhos recorrentes</span>.
        </p>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a href="#contato" className="btn-gold inline-flex items-center gap-2 px-8 py-4 rounded-xl text-base">
            Quero Ser Licenciado <ArrowRight className="w-4 h-4" />
          </a>
          <a href="#oportunidade" className="btn-outline-white inline-flex items-center gap-2 px-8 py-4 rounded-xl text-base font-semibold">
            Conhecer a Oportunidade
          </a>
        </div>

        <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-4 max-w-4xl mx-auto">
          {stats.map((s) => {
            const Icon = iconMap[s.icon];
            return (
              <div
                key={s.label}
                className="rounded-2xl border border-white/10 bg-white/5 backdrop-blur-sm px-4 py-5 text-center hover:border-emerald-400/40 transition-colors"
              >
                <div className="flex justify-center mb-2 text-amber-400">
                  {Icon && <Icon className="w-5 h-5" />}
                </div>
                <div className="text-white text-2xl md:text-3xl font-extrabold">{s.value}</div>
                <div className="text-slate-300 text-xs md:text-sm mt-1">{s.label}</div>
              </div>
            );
          })}
        </div>

        <div className="mt-10 text-slate-300 text-sm">Presente em todo o Brasil</div>

        <div className="mt-6 flex justify-center">
          <a
            href={whatsappUrl}
            target="_blank"
            rel="noreferrer"
            className="btn-gold inline-flex items-center gap-2 px-6 py-3 rounded-xl text-sm"
          >
            Chamar no WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
}
